export default __webpack_public_path__ + "media/images/pattern_orange-7a669ccccfc043a27a2caa0d63895439.png";